import { Page } from "@inertiajs/inertia";
import { usePage } from "@inertiajs/inertia-react";
import PageContext from "@inertiajs/inertia-react/src/PageContext";
import { useContext } from "react";

export default function usePageProps<T>()
: T
{
    // const page = useContext<Page & {props: T}>(PageContext)
    // const {props} = page ?? {props: {}};
    const page = usePage<Page & {props: T}>();

    return page.props;
}